module.exports = __webpack_public_path__ + "img/menu-delete-icon.21a942be.svg";